import React from 'react';
import { Column } from '../../components/column';
import { mobileFullWidthColumnClassName } from '../../utils/defaults';
import { Spacer } from '../../components/spacer';
import { ItemButton } from './item-button';
import { ItemDescription } from './item-description';
import { ItemImage } from './item-image';
import { ItemPrice } from './item-price';
import { ItemTitle } from './item-title';
import { itemGridColumn, itemGridSpacer } from './css-classes';
export var ItemsColumn = function (_a) {
    var _b, _c, _d, _e;
    var section = _a.section, item = _a.item, padding = _a.padding, width = _a.width;
    return (React.createElement(Column, { padding: padding, cssClass: itemGridColumn + " " + mobileFullWidthColumnClassName, width: width }, item && (React.createElement(React.Fragment, null,
        React.createElement(ItemImage, { item: item }),
        ((_b = section.show) === null || _b === void 0 ? void 0 : _b.title) !== false && (React.createElement(Spacer, { cssClass: itemGridSpacer, height: section.spacerHeight + "px" })),
        React.createElement(ItemTitle, { section: section, item: item }),
        ((_c = section.show) === null || _c === void 0 ? void 0 : _c.description) !== false && (React.createElement(Spacer, { cssClass: itemGridSpacer, height: section.spacerHeight + "px" })),
        React.createElement(ItemDescription, { section: section, item: item }),
        ((_d = section.show) === null || _d === void 0 ? void 0 : _d.price) !== false && (React.createElement(Spacer, { cssClass: itemGridSpacer, height: section.spacerHeight + "px" })),
        React.createElement(ItemPrice, { section: section, item: item }),
        ((_e = section.show) === null || _e === void 0 ? void 0 : _e.button) !== false && (React.createElement(Spacer, { cssClass: itemGridSpacer, height: section.spacerHeight + "px" })),
        React.createElement(ItemButton, { section: section, item: item })))));
};
//# sourceMappingURL=item-column.js.map